module.exports = __webpack_public_path__ + "static/media/logo_hdbank.5069c504.svg";